import { SCRUM_BOARD } from '@atlassian/jira-common-constants/src/board-types.tsx';
import type { BoardInfo } from '@atlassian/jira-navigation-apps-resources/src/services/sidebar/jsw-userboard-sidebar-navigation/types.tsx';
import type { Report } from '../../../common/types/index.tsx';
import messages from './messages.tsx';

const reports: Report[] = [
	{
		chart: 'burndownChart',
		id: 'agile-burndown-chart',
		message: messages.burndown,
		scrumOnly: true,
	},
	{
		chart: 'burnupChart',
		id: 'agile-burnup-chart',
		message: messages.burnup,
		scrumOnly: true,
	},
	{
		chart: 'sprintRetrospective',
		id: 'agile-sprint-retrospective',
		message: messages.sprint,
		scrumOnly: true,
	},
	{
		chart: 'velocity',
		id: 'agile-velocity-chart',
		message: messages.velocity,
		scrumOnly: true,
	},
	{
		chart: 'cumulativeFlowDiagram',
		id: 'agile-cumulative-flow-diagram',
		message: messages.flow,
		scrumOnly: false,
	},
	{
		chart: 'versionReport',
		id: 'agile-version-report',
		message: messages.version,
		scrumOnly: true,
	},
	{
		chart: 'epicReport',
		id: 'agile-epic-report',
		message: messages.epic,
		scrumOnly: true,
	},
	{
		chart: 'controlChart',
		id: 'agile-control-chart',
		message: messages.control,
		scrumOnly: false,
	},
	{
		chart: 'epicBurndown',
		id: 'agile-epic-burndown',
		message: messages.epicBurndown,
		scrumOnly: true,
	},
	{
		chart: 'releaseBurndown',
		id: 'agile-release-burndown',
		message: messages.releaseBurndown,
		scrumOnly: true,
	},
];

export const extractData = (board: BoardInfo): Report[] => {
	const isScrum = board.type === SCRUM_BOARD;

	return reports.filter(({ scrumOnly }) => (scrumOnly ? isScrum : true));
};
